import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * `cn` is the standard shadcn class-merge helper. Combines clsx (conditional
 * classes) with tailwind-merge (resolves conflicting Tailwind classes so
 * `cn("p-2", "p-4")` returns "p-4" instead of both).
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
